import {
	OnDestroy,
	Component,
	Input,
	OnChanges,
	OnInit, ViewChild,
	ViewEncapsulation
} from '@angular/core';
import {GalleryLayout} from  '@signature-it/ngx-generic/enums';
import {GalleryItemType} from  '@signature-it/ngx-generic/models';
import { CarouselService,ShareDataService } from '@signature-it/ngx-generic/services';
import { GalleryComponentGeneric } from '@signature-it/ngx-generic/components/gallery';
import { DomSanitizer } from '@angular/platform-browser';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from "@angular/router";
import {EntityService, SolrEntityService} from "@signature-it/ngx-entity/services";
import {PageRelatedItemPreviewEntityConfig} from "@signature-it/ngx-entity/models";
import {Store} from "@ngrx/store";
import * as EntityActions from '@signature-it/ngx-entity/store/actions';
import * as EntitySelectors from '@signature-it/ngx-entity/store/selectors';
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import { saveAs } from 'file-saver';

declare let _ : any;

@Component({
    selector: 'custom-preview-gallery',
    templateUrl: './custom-preview-gallery.component.html',
    styleUrls: ['./custom-preview-gallery.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomPreviewGalleryComponent extends GalleryComponentGeneric implements OnInit, OnChanges, OnDestroy {

	@Input() previewTemplateVar: string;
	@Input() popupMovieHeight: string = '600';
	@Input() popupMovieWidth: string = '1000';
	@Input() numberIndicators: boolean = false;
	@Input() allowDownload: boolean = false;
	activeIndex = 0;
	pageData: PageRelatedItemPreviewEntityConfig;
	templates$: Observable<any>;
	loadingTpl$: Observable<boolean>;
	protected destroy$: Subject<void> = new Subject<void>();

     constructor(protected carouselService: CarouselService,
				 protected modalService: NgbModal,
				 protected router: Router,
				 public sharedSvc: ShareDataService,
				 protected entityService: EntityService,
				 protected solrEntityService: SolrEntityService,
				 private sanitizer: DomSanitizer,
				 protected store$: Store<any>) {
		 super(carouselService, modalService, router, sharedSvc );
			 this.loadingTpl$ = this.store$.select(EntitySelectors.getIsLoadingPreviews);
			 this.templates$ = this.store$.select(EntitySelectors.getPreviews);
     }

	 async ngOnInit() {
		 this.store$.dispatch(EntityActions.getPreviews());
		 await super.ngOnInit();
		this.reItemsBuildArray();
	}

	ngOnChanges(changes) {
		 super.ngOnChanges(changes);
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}

	reItemsBuildArray(){
		this.templates$.pipe(takeUntil(this.destroy$)).subscribe(templates => {
			if(this.galleryItems) {
				this.galleryItems.forEach(item => {
					item['template'] = this.getCardTemplate(templates,item);
				});
				if (this.layout == GalleryLayout.CAROUSEL) {
					this.setCarouselItems();
				}
			}
		});
	}

	getCardTemplate(templates,keys) {
		if(!templates) return;
		let value = templates[this.previewTemplateVar];
		const regexp = /[$][$]mediaAsset[$][$]/g;
		if(value) {
			value = value.replace(regexp, ($1, $2) => {
				return this.getPreviewTemplate(keys['type']);
			});
		}
		return value;
	}

	getPreviewTemplate(type){
		 if(type == GalleryItemType.IMAGE || type == GalleryItemType.YOU_TUBE){
			return `<ngx-entity-preview-media open-popup-on-click="`+this.openPopupOnClick+`"  type="`+type+`" movieHeight="`+this.popupMovieHeight+`" movieWidth="`+this.popupMovieWidth + `"  src="%%src%%" thumb="%%thumb%%"></ngx-entity-preview-media>`;
		}
		 return '';
	}

	scrollAltCarousel(side: string, auto: boolean = false,index = null){
		if(this.entityConfig){
			let slideItems;
			if (auto) {
				slideItems = this.entityConfig.autoSlideItems ? this.entityConfig.autoSlideItems : 1;
			} else {
				slideItems = this.entityConfig.slideItems ? this.entityConfig.slideItems : 1;
			}
			if(this.altCarouselContainer){
				let itemWidth = this.altCarouselContainer.nativeElement.firstChild.clientWidth + (this.gridInfo['gutterHorizontal'] ? (Number(this.gridInfo['gutterHorizontal'].replace(/px$/, ''))*2):0);
				if(side == 'dot'){
					if(index == this.activeIndex){
						return;
					}
					if(index > this.activeIndex){
						slideItems = index - this.activeIndex;
						this.altCarouselContainer.nativeElement.scrollLeft -= (itemWidth * slideItems);

					}else{
						slideItems =  this.activeIndex - index;
						this.altCarouselContainer.nativeElement.scrollLeft += (itemWidth * slideItems);
					}
					this.activeIndex = index;
				}else if (side == 'right'){
					if(this.activeIndex > 0) {
						this.activeIndex--;
						this.altCarouselContainer.nativeElement.scrollLeft += (itemWidth * slideItems);
					}
				} else if (side == 'left'){
					if(this.galleryItems.length - 1 > this.activeIndex )
						this.activeIndex++;
					this.altCarouselContainer.nativeElement.scrollLeft -= (itemWidth * slideItems);
				}
			}
		} else {
			return;
		}
	}

	downloadImg(){
		switch (this.layout) {
			case GalleryLayout.CAROUSEL:
				let activeSlide = document.getElementsByClassName('carousel-item active')[0].getAttribute('data-slide-number');
				let img = this.carouselArray[activeSlide];
				this.download(img);
				break;
		}
	}

	downloadAllImgs(){
		switch (this.layout) {
			case GalleryLayout.CAROUSEL:
				var time = 5000;
				for (const img of this.carouselArray) {
					var setTimeoutDownload = setTimeout(() => {this.download(img)},time);
					time = time + 5000;
				}
				break;
		}
	}

	download(img) {
		saveAs(`${img[0].file_path}/${img[0].filename}`, img[0].filename);
	}
}
